const menu = require('../../../../../components/menu/menu')

export function start(detail, htmlDt, htmlFc) {
  const menuElem = menuBody[detail.id]

  for (let i = 0; i < menuElem.length; i++) {
    menuElem[i].start(detail, htmlDt, htmlFc)
  }

  detail.html = menuElem
  detail.act = 'show'
  menu.start(detail)
}

const menuBody = {
  fullcontOptions: [
    {
      text: '',
      svg: 'update',
      class: 'green',
      dataDetail: '',

      start: function (detail, htmlDt, htmlFc) {
        this.text = 'Restore'
        this.dataDetail = `data-detail='{
          "click": [
            {"dest":"ripple"},
            {"dest":"menu", "act":"hide"},
            {"dest":"purchaseDeleted", "elem":"fullcont", "id":"purchaseDeleted-fullcont", "act":"restore"}
          ]
        }'`
      }
    }
  ]
}
